module.exports = __webpack_public_path__ + "static/img/2.89217d0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/12/sp/2.png
// module id = vW6g
// module chunks = 0